import React, { useEffect } from 'react';
import { TWNavIconBlurbList } from '../TWNavIconBlurbList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWMobileNav = function TWMobileNav(_ref) {
  var topItems = _ref.topItems,
      bottomItems = _ref.bottomItems,
      leftSlot = _ref.leftSlot,
      bottomSlot = _ref.bottomSlot,
      onClose = _ref.onClose;
  useEffect(function () {
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = 'auto';
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: "fixed inset-0 flex z-40",
    children: /*#__PURE__*/_jsxs("nav", {
      className: "h-full w-full overflow-auto bg-gray-100",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-between bg-white px-4 py-3",
        children: [/*#__PURE__*/_jsx("div", {
          children: leftSlot
        }), /*#__PURE__*/_jsxs("button", {
          className: "inline-flex bg-transparent items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
          onClick: onClose,
          children: [/*#__PURE__*/_jsx("span", {
            className: "sr-only",
            children: "Close sidebar"
          }), /*#__PURE__*/_jsx("svg", {
            className: "h-6 w-6 text-inherit",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "aria-hidden": "true",
            children: /*#__PURE__*/_jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M6 18L18 6M6 6l12 12"
            })
          })]
        })]
      }), topItems.length > 0 && /*#__PURE__*/_jsx("div", {
        className: "bg-white px-4 py-4",
        children: /*#__PURE__*/_jsx(TWNavIconBlurbList, {
          items: topItems,
          onListItemClick: onClose
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "px-4 py-4",
        children: [/*#__PURE__*/_jsx(TWNavIconBlurbList, {
          items: bottomItems,
          onListItemClick: onClose
        }), bottomSlot]
      })]
    })
  });
};